import { render, staticRenderFns } from "./properties-block-youtube-video.vue?vue&type=template&id=b207d2c4&scoped=true"
import script from "./properties-block-youtube-video.vue?vue&type=script&lang=js"
export * from "./properties-block-youtube-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b207d2c4",
  null
  
)

export default component.exports